<template>
  <footer class="py-4" style="background-color: #020842;">
    <div class="container mx-auto px-4">
      <p class="text-sm text-center text-white">© 2025 Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
    methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>